import { z } from "zod";

export const EvaluationIdSchema = z.number().min(1).brand<'EvaluationId'>();

export type EvaluationId = z.infer<typeof EvaluationIdSchema>;
